import { createEffect } from 'effector';

import { getSubscriptions } from 'api/chargebee';

export const getSubscriptionsFx = createEffect(getSubscriptions);
